'use strict';

import $ from 'jquery';
import enquire from 'enquire.js';
import {bp} from '../../../_scripts/_helper';

export default class PrimaryMenu {
  constructor() {
    let $nav = $(".main-menu"),
        $nav_item = $nav.find("li"),
        $dropdown = $nav_item.has("ul");

    enquire.register("screen and (max-width:"+bp.minDesktop+"px)", {
      match : function() {
        let $back_btn = $nav_item.find("ul").prepend("<li class='js-back'><span><i class='icon icon-chevron-small-left'></i>back</span></li>");

        // open sub-level
        $dropdown.on("click.mobileNav", function(e) {
          console.debug('$dropdown.on("click")');
          e.stopPropagation();
          $(this).addClass("is-open");
          $(this).parent().addClass("slide-out");
        });

        // go back
        $back_btn.on("click", ".js-back", function(e) {
          e.stopPropagation();
          $(this).parents('.is-open').first().removeClass("is-open");
          $(this).parents('.slide-out').first().removeClass("slide-out");
        });
      },

      unmatch : function() {
        $dropdown.off('click.mobileNav');
        $nav_item.find(".js-back").remove();
      }
    });



    // update the cart menu with the items stored in local storage
    if(typeof(Storage) !== "undefined") {
      if(localStorage.getItem("productsInCart") !== null) {

        let productsInCart = JSON.parse(localStorage.getItem("productsInCart")),
            cartQuantity = 0;
        productsInCart.forEach(function(product) {
          cartQuantity += Number(product.prodQty);
        });

        $('.cart-menu .cart-items').text('('+parseInt(cartQuantity)+')'); // update the cart the return value
        // $('.cart-menu .cart-items').text('('+JSON.parse(localStorage.getItem("productsInCart")).length+')'); // update the cart the return value
        $('.mobile-cart-icon .cart-items').addClass('has-item'); // update the cart icon in mobile
      }
    }
  }



}
